import React, { Suspense, useEffect, useState } from 'react';
import { useAllBook } from 'store/books/selectors';
import { useClassActivities } from 'store/classActivities/selectors';
import { useClassQuizzes } from 'store/classQuizzes/selectors';
import { useCurrentClass } from 'store/classes/selectors';
import { sortname } from "utils/methods/math";
// import { useServertime } from 'store/servertime/selectors';
import { useClassSubmissions } from 'store/submissions/selectors';
import { useUsersByClass } from "store/userClasses/selectors";
import { get, find, map, filter, groupBy, uniqBy ,cloneDeep} from "lodash"
import { Drawer } from "antd"
import Loading from 'components/Loading';
import { useUserPreference } from "store/userPreference/selectors"

import AssignmentReview from 'features/forms/AssignmentReview';
import { useDispatch, useSelector } from 'react-redux';
import { handleListClassSubmissions } from 'store/submissions/thunks';
import { useCurrentOrg } from "store/organizations/selectors"
import * as Sentry from '@sentry/react';
import { useClassGameActivity } from 'store/one_game/selectors';
import { useAlert } from './UI/alertSakeBar/alertProvider';
import SentryWrap from 'components/Sentry';
export default function AssignmentReviewByNotify({ assignment, oncloseDrawer, assignmentDrawer, selectedNotification }) {
    const showAlert = useAlert();
    const classActivities = useClassActivities()
    const { class_game_activity } = useClassGameActivity()
    const usersByClass = useUsersByClass()
    const classQuizzes = useClassQuizzes()
    const submissions = useClassSubmissions()
    const booksAllList = useAllBook()
    const dispatch = useDispatch();
    const currentClass = useCurrentClass()
    const userPreference = useUserPreference()
    const currentOrg = useCurrentOrg()
    const [selectedAssignmentUserSubmission, setSelectedAssignmentSubmissions] = useState([])
    const [assignmentData, setAssignmentData] = useState({});
    const filteredClassUsers = filter(usersByClass?.[get(currentClass, "id")] || [], (user) => user?.role === 'student')
    const currentClassUsers = usersByClass ? filteredClassUsers : []
    const studentSubmissions = groupBy(submissions, 'userId');
    const users = useSelector((state) => state.classUsers);
    const [listStudentUser,setListStudentUser] = useState(users && users.length > 0 ? filter(users, x => x.role === 'student' && x?.userclass?.active === true).sort(sortname) : new Array(1).fill({}, 0, 1))
    const firstStudent = currentClassUsers ? currentClassUsers[0] : {}

    useEffect(() => {
        const allstudents = uniqBy(filter(users, x => x.role === 'student').sort(sortname), "username");
        const viewStudents = allstudents.filter(u => u?.userclass?.active === true);
        const finalList = viewStudents.length > 0 ? viewStudents : [];
        setListStudentUser(finalList);
    }, [users, sortname])


    const fetchAllData = async () => {
        dispatch(handleListClassSubmissions(get(currentClass, "id")))
    }
    const getAssignmentCreation = (assignmentdata, userdata) => {
        try {
            let _assignmentinfo = assignmentdata?.type === 'worksheet' ? assignmentdata?.assignment : assignmentdata.data ?? {};
            let quizdata = {
                answers: [],
                assignment: _assignmentinfo,
                assignmentId: _assignmentinfo.id,
                assignmentType: _assignmentinfo.typeId,
                chapter: _assignmentinfo.chapter,
                classId: currentClass?.id,
                complete: false,
                createdAt: Date.now(),
                feedback: '',
                grade: null,
                face_grade: null,
                graded: true,
                isLate: false,
                orgId: currentOrg?.id,
                retakes: assignmentdata.retakes,
                retaking: false,
                submissions: 0,
                timmer: 0,
                user: userdata,
                userId: userdata?.id,
                bookId: _assignmentinfo.bookId,
                isTemp: true
            }
            return quizdata;
        } catch (error) {
            Sentry.captureException(`150 Error in getAssignmentCreation: ${error}`);
            return {};
        }
    }
    const reviewAssignment = (data, tempData, users, userSubmissions) => {
        const _assignment = [...classActivities, ...classQuizzes, ...class_game_activity].filter(a => a?.session_id ? get(a, 'session_id', '') == get(data, "assignmentId") : (a.quizId === get(data, "assignmentId")) || a.activityId === get(data, "assignmentId"))[0];
        let sAssignmentId = get(data, "sAssignmentId");
        if (_assignment && _assignment.sAssignmentId) {
            sAssignmentId = _assignment.sAssignmentId;
        }
        if (data) {
            data.sAssignmentId = sAssignmentId;
        }
        if (!data) {
            const utemp = cloneDeep(tempData);
            utemp.isTemp = true;
            data = utemp;
            data.sAssignmentId = sAssignmentId;
        }
        const userdata = map(users || [], usr => {
            if (!usr || !usr.id) return null;
            const sub = userSubmissions[usr.id]
            if (sub) {
                const asub = find(sub, n => get(n, "assignmentId") == get(data, "assignmentId", get(tempData, "assignmentId")))
                if (asub) {
                    asub.sAssignmentId = sAssignmentId;
                    return asub
                } else {
                    const utemp = cloneDeep(tempData);
                    utemp.userId = usr.id;
                    utemp.user = usr;
                    utemp.isTemp = true;
                    utemp.sAssignmentId = sAssignmentId;
                    return utemp;
                }
            } else {
                const utemp = cloneDeep(tempData);
                utemp.userId = usr.id;
                utemp.user = usr;
                utemp.isTemp = true;
                utemp.sAssignmentId = sAssignmentId;
                return utemp;
            }
        })
        if(userdata.length==0){
            oncloseDrawer()
            showAlert('No student submissions are available for this class.', "error");
            setSelectedAssignmentSubmissions([])
            setAssignmentData({})
            return;
        }
        setSelectedAssignmentSubmissions(userdata)
        setAssignmentData(data);
        // toggleAssignmentDrawer(true);
    };
    const onClick = () => {
        const assignmentId = assignment?.activityId || assignment?.data?.id;
        const senderId = get(selectedNotification, "senderId", "");
        const classId = get(currentClass, "id");

        let firstStudentOfClass = (currentClassUsers || []).find(user => get(user, "id") === senderId);

        if (!firstStudentOfClass) {
            const matchedSubmission = (submissions || []).find(sub => sub?.assignmentId === assignmentId);
            if (matchedSubmission) {
                firstStudentOfClass = usersByClass[classId]?.find(user => user.id === matchedSubmission.userId);
            } else {
                firstStudentOfClass = firstStudent;
            }
        }

        const assignmentData = getAssignmentCreation(assignment, firstStudentOfClass);
        const studentId = firstStudentOfClass?.id;
        const studentSubs = studentSubmissions[studentId] || [];
        const existingSubmission = studentSubs.find(sub => get(sub, "assignmentId") === assignmentId);

        const finalData = existingSubmission || assignmentData;

        reviewAssignment(finalData, assignmentData, listStudentUser, studentSubmissions);
    };
    useEffect(() => {
        onClick()
    }, [assignment, assignmentDrawer, selectedNotification])
    const onClose = () => {
        // toggleAssignmentDrawer(false)
        oncloseDrawer()
    }
    return (
        <SentryWrap>
            <Drawer
            height='100%'
            destroyOnHidden
            onClose={() => {
                // toggleAssignmentDrawer(false);
                setAssignmentData({});
                setSelectedAssignmentSubmissions([])
                oncloseDrawer()
            }}
            placement='top'
            open={assignmentDrawer}
            key='assignmentNew'
            className='student-review-new'
        >
            {assignmentDrawer ? (
                <Suspense fallback={<Loading />}>
                    <AssignmentReview
                        open={assignmentDrawer}
                        booksAllList={booksAllList}
                        data={assignmentData}
                        usersSubmissionData={selectedAssignmentUserSubmission}
                        currentClass={currentClass}
                        handleClose={() => {
                            onClose()
                            fetchAllData();
                        }}
                        scale_1_5={userPreference?.gradePref == "scale_1_5"}
                        gradebook_a_f={userPreference?.gradePref === "gradebook_a_f"}
                        showAlert={showAlert}
                    />
                </Suspense>
            ) : null}
        </Drawer>
        </SentryWrap>
    )
}
